import { makeSelectToken, updateInitialState } from "@features/auth/authSlice";
import { getCombinedStorageValue } from "@utils/helpers";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ProtectedRoutes = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = useSelector(makeSelectToken);

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true);
      const decoded = jwtDecode(token);
      if (
        !(
          typeof decoded === "object" &&
          typeof decoded.exp === "number" &&
          decoded.exp > Date.now() / 1000
        )
      ) {
        localStorage.clear();
      } else {
        const routes = getCombinedStorageValue("routes", true);
        const user = {
          id: decoded.id,
          name: decoded.name,
          avatar: decoded.avatar,
          email: decoded.email,
          roles: decoded.roles,
          role_type: decoded.role_type,
          email_verified: decoded.email_verified,
          mobile_no: decoded.mobile_no,
          seller_ref_id: decoded.seller_ref_id,
          otp_verified: decoded.mobile_no,
          is_verified: decoded.is_verified,
          sub_domain: decoded.sub_domain,
          routes: routes ?? [],
        };
        dispatch(updateInitialState({ token: token, data: user }));
      }
    } else {
      navigate(`/`);
    }
  }, [token]);

  if (isAuthenticated) {
    return <>{children}</>;
  }
  return <></>;
};

export default ProtectedRoutes;
